"use strict";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgent = exports.pool = void 0;

var http_1 = require("http");

var https_1 = require("https"); // eslint-disable-next-line node/no-deprecated-api


var url_1 = require("url");

exports.pool = new Map();
/**
 * Returns a custom request Agent if one is found, otherwise returns undefined
 * which will result in the global http(s) Agent being used.
 * @private
 * @param {string} uri The request uri
 * @param {Options} reqOpts The request options
 * @returns {HttpAnyAgent|undefined}
 */

function getAgent(uri, reqOpts) {
  var isHttp = uri.startsWith('http://');
  var proxy = reqOpts.proxy || process.env.HTTP_PROXY || process.env.http_proxy || process.env.HTTPS_PROXY || process.env.https_proxy;
  var poolOptions = Object.assign({}, reqOpts.pool);

  if (proxy) {
    // tslint:disable-next-line variable-name
    var Agent = isHttp ? require('http-proxy-agent') : require('https-proxy-agent');

    var proxyOpts = _objectSpread({}, url_1.parse(proxy), {}, poolOptions);

    return new Agent(proxyOpts);
  }

  var key = isHttp ? 'http' : 'https';

  if (reqOpts.forever) {
    key += ':forever';

    if (!exports.pool.has(key)) {
      // tslint:disable-next-line variable-name
      var _Agent = isHttp ? http_1.Agent : https_1.Agent;

      exports.pool.set(key, new _Agent(_objectSpread({}, poolOptions, {
        keepAlive: true
      })));
    }
  }

  return exports.pool.get(key);
}

exports.getAgent = getAgent;